require('angular').module('wowApp.common')
    .service('SuggestedListService', ['Restangular', '$q', 'BootstrapService', require('./suggestedlist-service')]);


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/suggestedlist/index.js
 **/